// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/picture/background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Premium Dark Theme Palette */
  --bg-primary: #0a0a0b;
  --bg-secondary: #121214;
  --bg-tertiary: #1c1c1f;

  --text-primary: #ededed;
  --text-secondary: #a1a1aa;
  --text-tertiary: #52525b;

  --primary-color: #6d28d9;
  /* Deep Purple */
  --primary-hover: #5b21b6;
  --primary-glow: rgba(109, 40, 217, 0.5);

  --accent-color: #ec4899;
  /* Pink */
  --accent-glow: rgba(236, 72, 153, 0.5);

  --success: #10b981;
  --error: #ef4444;

  --glass-bg: rgba(255, 255, 255, 0.05);
  --glass-border: rgba(255, 255, 255, 0.1);
  --glass-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);

  --radius-sm: 0.375rem;
  --radius-md: 0.5rem;
  --radius-lg: 1rem;
  --radius-full: 9999px;

  --font-sans: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;

  --transition-base: all 0.2s ease-in-out;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html {
  /* Background image with dark overlay */
  background:
    linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
  /* Fallback color if image fails to load */
  background-color: #000000;
  /* Full height - use vh as fallback */
  min-height: 100%;
  height: 100vh;
}

@supports (height: 100dvh) {
  html {
    height: 100dvh;
  }
}

body {
  font-family: var(--font-sans);
  background: transparent;
  margin: 0;
  padding: 0;
  /* Full height - vh as fallback, dvh if supported */
  min-height: 100vh;
}

@supports (min-height: 100dvh) {
  body {
    min-height: 100dvh;
  }
}

/* Typography */
h1,
h2,
h3,
h4,
h5,
h6 {
  color: var(--text-primary);
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 1rem;
}

h1 {
  font-size: 2.5rem;
  background: linear-gradient(135deg, #fff 0%, var(--text-secondary) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

a {
  color: var(--primary-color);
  text-decoration: none;
  transition: var(--transition-base);
}

a:hover {
  text-decoration: none;
  color: var(--accent-color);
}

/* Utilities */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1.5rem;
  border-radius: var(--radius-md);
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition-base);
  border: 1px solid transparent;
  outline: none;
  font-size: 1rem;
}

.btn-primary {
  background-color: var(--primary-color);
  color: white;
  box-shadow: 0 0 15px var(--primary-glow);
}

.btn-primary:hover {
  background-color: var(--primary-hover);
  transform: translateY(-1px);
}

.glass-card {
  background: var(--glass-bg);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid var(--glass-border);
  border-radius: var(--radius-lg);
  padding: 2rem;
  box-shadow: var(--glass-shadow);
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: var(--bg-secondary);
}

::-webkit-scrollbar-thumb {
  background: var(--text-tertiary);
  border-radius: var(--radius-full);
}

::-webkit-scrollbar-thumb:hover {
  background: var(--text-secondary);
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;;EAEtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;;EAExB,wBAAwB;EACxB,gBAAgB;EAChB,wBAAwB;EACxB,uCAAuC;;EAEvC,uBAAuB;EACvB,SAAS;EACT,sCAAsC;;EAEtC,kBAAkB;EAClB,gBAAgB;;EAEhB,qCAAqC;EACrC,wCAAwC;EACxC,qFAAqF;;EAErF,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;;EAErB,4JAA4J;;EAE5J,uCAAuC;AACzC;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,uCAAuC;EACvC;;mEAEgE;EAChE,sBAAsB;EACtB,4BAA4B;EAC5B,0CAA0C;EAC1C,yBAAyB;EACzB,qCAAqC;EACrC,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,mDAAmD;EACnD,iBAAiB;AACnB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA,eAAe;AACf;;;;;;EAME,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wEAAwE;EACxE,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,6BAA6B;EAC7B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,mCAAmC;EACnC,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,+BAA+B;AACjC;;AAEA,cAAc;AACd;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');\r\n\r\n:root {\r\n  /* Premium Dark Theme Palette */\r\n  --bg-primary: #0a0a0b;\r\n  --bg-secondary: #121214;\r\n  --bg-tertiary: #1c1c1f;\r\n\r\n  --text-primary: #ededed;\r\n  --text-secondary: #a1a1aa;\r\n  --text-tertiary: #52525b;\r\n\r\n  --primary-color: #6d28d9;\r\n  /* Deep Purple */\r\n  --primary-hover: #5b21b6;\r\n  --primary-glow: rgba(109, 40, 217, 0.5);\r\n\r\n  --accent-color: #ec4899;\r\n  /* Pink */\r\n  --accent-glow: rgba(236, 72, 153, 0.5);\r\n\r\n  --success: #10b981;\r\n  --error: #ef4444;\r\n\r\n  --glass-bg: rgba(255, 255, 255, 0.05);\r\n  --glass-border: rgba(255, 255, 255, 0.1);\r\n  --glass-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\r\n\r\n  --radius-sm: 0.375rem;\r\n  --radius-md: 0.5rem;\r\n  --radius-lg: 1rem;\r\n  --radius-full: 9999px;\r\n\r\n  --font-sans: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\r\n\r\n  --transition-base: all 0.2s ease-in-out;\r\n}\r\n\r\n* {\r\n  box-sizing: border-box;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nhtml {\r\n  /* Background image with dark overlay */\r\n  background:\r\n    linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),\r\n    url('./assets/picture/background.png') no-repeat center center;\r\n  background-size: cover;\r\n  background-attachment: fixed;\r\n  /* Fallback color if image fails to load */\r\n  background-color: #000000;\r\n  /* Full height - use vh as fallback */\r\n  min-height: 100%;\r\n  height: 100vh;\r\n}\r\n\r\n@supports (height: 100dvh) {\r\n  html {\r\n    height: 100dvh;\r\n  }\r\n}\r\n\r\nbody {\r\n  font-family: var(--font-sans);\r\n  background: transparent;\r\n  margin: 0;\r\n  padding: 0;\r\n  /* Full height - vh as fallback, dvh if supported */\r\n  min-height: 100vh;\r\n}\r\n\r\n@supports (min-height: 100dvh) {\r\n  body {\r\n    min-height: 100dvh;\r\n  }\r\n}\r\n\r\n/* Typography */\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n  color: var(--text-primary);\r\n  font-weight: 700;\r\n  line-height: 1.2;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\nh1 {\r\n  font-size: 2.5rem;\r\n  background: linear-gradient(135deg, #fff 0%, var(--text-secondary) 100%);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n}\r\n\r\na {\r\n  color: var(--primary-color);\r\n  text-decoration: none;\r\n  transition: var(--transition-base);\r\n}\r\n\r\na:hover {\r\n  text-decoration: none;\r\n  color: var(--accent-color);\r\n}\r\n\r\n/* Utilities */\r\n.container {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  padding: 0 2rem;\r\n}\r\n\r\n.btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 0.75rem 1.5rem;\r\n  border-radius: var(--radius-md);\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: var(--transition-base);\r\n  border: 1px solid transparent;\r\n  outline: none;\r\n  font-size: 1rem;\r\n}\r\n\r\n.btn-primary {\r\n  background-color: var(--primary-color);\r\n  color: white;\r\n  box-shadow: 0 0 15px var(--primary-glow);\r\n}\r\n\r\n.btn-primary:hover {\r\n  background-color: var(--primary-hover);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.glass-card {\r\n  background: var(--glass-bg);\r\n  backdrop-filter: blur(12px);\r\n  -webkit-backdrop-filter: blur(12px);\r\n  border: 1px solid var(--glass-border);\r\n  border-radius: var(--radius-lg);\r\n  padding: 2rem;\r\n  box-shadow: var(--glass-shadow);\r\n}\r\n\r\n/* Scrollbar */\r\n::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background: var(--bg-secondary);\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background: var(--text-tertiary);\r\n  border-radius: var(--radius-full);\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: var(--text-secondary);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
